module.exports = __webpack_public_path__ + "static/media/certonce_logo.2ee341aa.png";